<template>
  <div class="container">
    <div class="row">
      <div
        class="col-6 col-sm-3 video-list"
        v-for="(item,index) in videoList"
        :key="item.id"
        @mouseenter="enter(index)"
        @mouseleave="leave()"
        @click="clickVideo(item.code)"
      >
        <div class="video-list-img">
          <!-- <img :src="require('@/assets/images/video-image.png')" alt /> -->
          <img :src="item.image" alt />
          <span v-if="index == activeIndex" class="play-btn"></span>
        </div>
        <p style="width:100%;text-align:center; overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.title}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: '',
  data() {
    return {
      activeIndex: '-1'
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['videoList'])
  },
  created() {
    this.utils.refreshVideoList()
  },
  methods: {
    clickVideo(codeId) {
      if (this.$route.params.code != codeId) this.$router.push({ name: 'VideoDetail', params: { code: codeId } })
    },
    enter(index) {
      this.activeIndex = index
    },
    leave() {
      this.activeIndex = '-1'
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  margin-top: 20px;
  margin-bottom: 20px;
  .video-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
    cursor: pointer;
    .video-list-img {
      width: 100%;
      height: 150px;
      margin-bottom: 10px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .play-btn {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url('../../../assets/svg/icon-play.svg') no-repeat;
        background-position: center;
        background-size: auto 40%;
      }
    }

    p {
      margin-bottom: 0;
    }
  }
}
</style>